import { useTier } from '../../hooks/useTier'
import { StandaloneDashboard } from './StandaloneDashboard'
import { ConsultantDashboard } from './ConsultantDashboard'
import { EnterpriseDashboard } from './EnterpriseDashboard'

export function Dashboard() {
  const tier = useTier()

  if (tier === 'consultant') return <ConsultantDashboard />
  if (tier === 'enterprise') return <EnterpriseDashboard />
  return <StandaloneDashboard />
}
